export type PhoneCountryCode = {
  code: string;
  dialCode: string;
  flag: string;
  name: string;
};

export const PHONE_COUNTRY_CODES: PhoneCountryCode[] = [
  { code: "CI", dialCode: "+225", flag: "🇨🇮", name: "Côte d'Ivoire" },
  { code: "FR", dialCode: "+33", flag: "🇫🇷", name: "France" },
  { code: "SN", dialCode: "+221", flag: "🇸🇳", name: "Sénégal" },
  { code: "CM", dialCode: "+237", flag: "🇨🇲", name: "Cameroun" },
  { code: "CD", dialCode: "+243", flag: "🇨🇩", name: "RD Congo" },
  { code: "CG", dialCode: "+242", flag: "🇨🇬", name: "Congo" },
  { code: "GA", dialCode: "+241", flag: "🇬🇦", name: "Gabon" },
  { code: "BF", dialCode: "+226", flag: "🇧🇫", name: "Burkina Faso" },
  { code: "ML", dialCode: "+223", flag: "🇲🇱", name: "Mali" },
  { code: "GN", dialCode: "+224", flag: "🇬🇳", name: "Guinée" },
  { code: "TG", dialCode: "+228", flag: "🇹🇬", name: "Togo" },
  { code: "BJ", dialCode: "+229", flag: "🇧🇯", name: "Bénin" },
  { code: "NE", dialCode: "+227", flag: "🇳🇪", name: "Niger" },
  { code: "TD", dialCode: "+235", flag: "🇹🇩", name: "Tchad" },
  { code: "CF", dialCode: "+236", flag: "🇨🇫", name: "Centrafrique" },
  { code: "MA", dialCode: "+212", flag: "🇲🇦", name: "Maroc" },
  { code: "DZ", dialCode: "+213", flag: "🇩🇿", name: "Algérie" },
  { code: "TN", dialCode: "+216", flag: "🇹🇳", name: "Tunisie" },
  { code: "MG", dialCode: "+261", flag: "🇲🇬", name: "Madagascar" },
  { code: "RW", dialCode: "+250", flag: "🇷🇼", name: "Rwanda" },
  { code: "BI", dialCode: "+257", flag: "🇧🇮", name: "Burundi" },
  { code: "KE", dialCode: "+254", flag: "🇰🇪", name: "Kenya" },
  { code: "HT", dialCode: "+509", flag: "🇭🇹", name: "Haïti" },
  { code: "BE", dialCode: "+32", flag: "🇧🇪", name: "Belgique" },
  { code: "CH", dialCode: "+41", flag: "🇨🇭", name: "Suisse" },
  { code: "CA", dialCode: "+1", flag: "🇨🇦", name: "Canada" },
  { code: "US", dialCode: "+1", flag: "🇺🇸", name: "États-Unis" },
  { code: "GB", dialCode: "+44", flag: "🇬🇧", name: "Royaume-Uni" },
];
